
export const RAW_MOVILITY_TYPES = ['Coche', 'Autocaravana', 'Autobús', 'Bicicleta', 'Moto', 'Avión', 'Tren'] as const;
